import api from "./index";

/**
 * Email-type catalogue API.
 *
 * The backend exposes a list of every automated email the platform sends,
 * each with an `enabled` kill switch. The admin Settings -> Email tab reads
 * and updates these.
 */

// Fetch the full email-type catalogue (one entry per email type).
export const fetchEmailTypes = async () => {
  const response = await api.get("/notifications/email-types/");
  return response.data;
};

// Persist toggle changes. `updates` is an array of { key, enabled }.
export const updateEmailTypes = async (updates) => {
  const response = await api.post("/notifications/email-types/", updates);
  return response.data;
};
